import {schemeLists, successSchemeLists, productList} from './../../plugins/js/data';

$(() => {
    //赛事专业系统解决方案
    $('.scheme-menu-btn').click(function(e){
        const picker = new mui.PopPicker();
        let _data = schemeLists.map(item=>{
            if(item.btnText) return {
                ...item,
                text: item.btnText,
                value: item.id
            }
        });
        picker.setData(_data.filter(item=>item));
        picker.show(function (selectItems) {
            selectSchemeItem(selectItems[0].value)
        })
    })

    //首图轮播图展示索引
    let headImgIndex = 1;
    function startHeadImgScroll(){
        $('.jumpScore').click(function(){
            window.open('https://scoreshow.sportscv.cn');
        })
        window.headTimer && clearInterval(window.headTimer);
        window.headTimer = setInterval(()=>{
            headImgIndex += 1;
            if(headImgIndex > 2){
                headImgIndex = 1
            }
            headImgController(headImgIndex);
        }, 4000)
    }
    startHeadImgScroll();
    function headImgController(index){
        let screenWidth = window.innerWidth;
        if(screenWidth >=1200) screenWidth=1200;
        console.log($(`.news-recent>.img`));
        $(`.head-img.big-screen-item>img.active`).removeClass('active');
        $(`.head-img.small-screen-item>img.active`).removeClass('active');
        $(`.head-img.big-screen-item>.img${headImgIndex}`).addClass('active');
        $(`.head-img.small-screen-item>.img${headImgIndex}`).addClass('active');
    }
    //最新动态轮流切换显示
    let newsIndex = 1;
    function newsController(index){
        let screenWidth = window.innerWidth;
        if(screenWidth >=1200) screenWidth=1200;
        newsIndex = index;
        $(`.news-recent>img.active`).removeClass('active');
        $(`.news-recent>.img${newsIndex}`).addClass('active');

        $(`.news-recent .news-item.active`).removeClass('active');
        $(`.news-recent .news-item${newsIndex}`).addClass('active');
        $('.news-list-container').css('margin-left', -(newsIndex - 1) * screenWidth + 'px');

        $('.news-controller ul li.active').removeClass('active');
        $('.news-controller ul li').eq(index-1).addClass('active');
    }
    function startNewsScroll(){
        window.newsTimer && clearInterval(window.newsTimer);
        window.newsTimer = setInterval(()=>{
            newsIndex += 1;
            if(newsIndex > 3){
                newsIndex = 1
            }
            newsController(newsIndex);
        }, 30000)
    }
    startNewsScroll();
    $('.news-recent video').each((index, dom)=>{
        dom.onplay = function(){
            window.newsTimer && clearInterval(window.newsTimer);
        }
        dom.onpause = function(){
            startNewsScroll();
        }
    })
    $('.news-controller ul li').click(function(e){
        newsController($(this).index() + 1);
        startNewsScroll();
    })

    //场馆专业系统解决方案 元素填充 切换
    // renderSchemeBtns();
    renderScheme();
    new Swiper('.swiper-container', {
        loop: true, // 循环模式选项
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        }
    });
    $('.scheme-items').on('click', 'div.item', e => {
        let id = e.target.id;
        selectSchemeItem(id, e)
    });
    function selectSchemeItem(id,e ){
        let prevIndex = $('.scheme-items .item.active').index();
        let nowIndex = 0;
        if(e) nowIndex = $(e.target).index();

        $('.scheme-items .item').each(function () {
            let className = $(this).attr('class');
            if (className.indexOf('active') !== -1) {
                $(this).removeClass('active');
            }
        });

        if(e) $(e.target).addClass('active');
        $("#scheme .scheme-content .scheme-item").removeClass('active');
        let dom = $(`#scheme .scheme-content .${ id }`);
        dom.removeClass('animate__animated animate__fadeInRight animate__fadeInLeft');
        setTimeout(() => {
            dom.addClass('active animate__animated ' + (nowIndex > prevIndex ? 'animate__fadeInRight' : 'animate__fadeInLeft'));
        });
    }
    //随机展示一个方案
    $('.scheme-items div.item').eq(Math.floor(Math.random()*10)).click();

    //产品展示
    // renderProduct();
    $('.product-more-shadow-btn').click(function () {
        $("#product-show .item.hidden").css({display: "block"});
        $(".product-more-shadow").remove();
        checkScrollForAnimate();
    });

    //大型场馆项目案例
    $("#big-scheme .dot.more").click(function () {
        $("#big-scheme .item.hidden").css("display", "flex");
        checkScrollForAnimate();
        $(this).remove();
    });

    //成功案例渲染、 切换逻辑
    renderSuccess();
    let success_show_index = 1;
    let success_show_length = successSchemeLists.length;
    let success_show_count_width = 300;
    renderSuccessBindClick();
    window.onresize = ()=>{
        renderSuccessBindClick();
    }
    function renderSuccessBindClick(){
        renderSuccess();
        if(window.innerWidth < 415){
            success_show_count_width = 300;
        }
        $("#success-scheme .item-container .item").click(function () {
            let success_show_index = $(this).index();
            let length = success_show_length + 2;

            if(success_show_index === 0){
                success_show_index = length - 2;
            }else if(success_show_index === (length - 1)){
                success_show_index = 1;
            }
            $("#success-scheme .item-container .active").removeClass('active');
            $("#success-scheme .item-container .item").eq(success_show_index).addClass('active');
            $("#success-scheme .item-container").css('margin-left', success_show_count_width - success_show_count_width * success_show_index);
        });
    }
    $("#success-scheme .icon").click(function () {
        if ($(this).attr('class').indexOf('icon-prev') !== -1) {
            if (success_show_index === 1) success_show_index = success_show_length + 1;
            success_show_index -= 1;
        } else {
            if (success_show_index === success_show_length) success_show_index = 0;
            success_show_index += 1;
        }
        $("#success-scheme .item-container .active").removeClass('active');
        $("#success-scheme .item-container .item").eq(success_show_index).addClass('active');
        $("#success-scheme .item-container").css('margin-left', success_show_count_width - success_show_count_width * success_show_index);
    });

    //连续多年，荣获多项业界好评 大图展示
    $(".cetifacate-containers .imgs").on('click', 'img', e => {
        let src = e.target.src;
        // viewImg(src);
    });

    //合作商渲染 无缝滚动
    renderPartner();
    $("#official-partner .items").addClass('animate');


    checkScrollForAnimate();
    window.onscroll = function () {
        checkScrollForAnimate();
        if(window.innerWidth > 414){
            checkForHeaderActive();
        }
    };


    //渲染场馆专业系统解决方案
    function renderSchemeBtns() {
        let str = ``;
        schemeLists.map((item, index) => {
            if(item.onlyDetail) return null;
            str += `<div class="item" id=${ item.id }>${ item.btnText }</div>`;
        });
        $("#scheme .scheme-items").html(str);
    }

    function renderScheme() {
        let str = ``;
        schemeLists.map((item, index) => {
            if(item.onlyDetail) return null;
            let imgsStr = ``;
            let descStr = ``;
            if (item.imgs) {
                let imgs = ``;
                if (item.imgs.length > 1) {
                    item.imgs.map((it, index) => {
                        imgs += `<div class="swiper-slide">
                                    <a href=${ item.html ? `./html/${ item.html }` :  item.descText ? `./html/scheme.html?id=${ item.id }` : "javascript:;"}>
                                        <img src="/img/index/scheme/${it}" alt=${ item.title }>
                                    </a>
                                 </div>`;
                    });
                    imgsStr =
                        `
                            <div class="swiper-container">
                                <div class="swiper-wrapper">${ imgs }</div>
                                <div class="swiper-pagination"></div>
                            </div>
                    `;
                } else {
                    imgsStr = `<div class="item-img">
                                    <a href=${ item.html ? `./html/${ item.html }` :  item.descText ? `./html/scheme.html?id=${ item.id }` : "javascript:;"}>
                                        <img src="/img/index/scheme/${item.imgs[0]}"  alt=${ item.title }>
                                    </a>
                                </div>`
                }
            }
            if (item.descList) {
                item.descList.map((it, _index) => {
                    descStr +=
                        `<li>
                            <div class="icon"><img src="/img/index/scheme/${ it.icon }" alt=""></div>
                            <div class="desc"><span class="no">0${ _index + 1 }</span><span class="text">${ it.text }</span></div>
                        </li>`;
                })
            }
            str +=
                `<div class="scheme-item ${ item.id }">
                    ${imgsStr}<div
                     class="content">
                        <h3>
                            <a href=${ item.html ? `./html/${ item.html }` :  item.descText ? `./html/scheme.html?id=${ item.id }` : "javascript:;"}
                               title=${ item.title }
                            >
                                ${ item.title }
                            </a>
                        </h3>
                        <ul>${ descStr }</ul>
                    </div>  
                </div>`;
        });
        $("#scheme .scheme-content").html(str);
    }

    //渲染产品展示
    function renderProduct() {
        let html = '';
        productList.forEach((item, index) => {
            html +=
                `<div class="item ${ index > 3 ? 'hidden' : null }">
                    <div class="img">
                        <img src="/img/index/${ item.img }" alt="">
                    </div>
                    <div class="product-title">
                        <a href=${ item.params ? `html/product.html?id=${ item.id }` : 'javascript:;' }>${ item.title }</a><br/>
                        <!--<a href=${ item.params ? `html/product.html?id=${ item.id }` : 'javascript:;' }>${ item.title2 }</a>-->
                    </div>
                    <div class="desc">${ item.desc }</div>
                </div>`;
        });
        $("#product-show .products").html(html);
    }

    //渲染成功案例
    function renderSuccess() {
        let str = ``;
        let list = [...successSchemeLists];
        list.unshift(successSchemeLists[successSchemeLists.length -1]);
        list.push(successSchemeLists[0]);

        list.map((item, index) => {
            str +=
                `<div class="item ${ index === 2 ? 'active' : '' }">
                    <div class="img">
                        <img src="/img/index/successscheme/${ item.img }" alt="">
                    </div>
                    <div class="title">${ item.title }</div> 
                    <div class="desc">${ item.text }</div> 
                </div>`;
        });
        $("#success-scheme .item-container").html(str);
    }

    //渲染合作商
    function renderPartner() {
        let dom = ``;
        new Array(9).fill("").forEach((item, index) => {
            if(index === 1) return '';
            if(index === 3) return '';
            if(index === 4) return '';
            if(index === 6) return '';
            dom +=
                `<div class="item">
                    <img src="/img/index/partner/partner${ index + 1 }.jpg" alt="">
                </div>`
        });
        $("#official-partner .items").html(dom + dom);
    }

    //大图预览
    function viewImg(src) {
        let shadow = $(`<div class="global-shadow"></div>`);
        shadow.html(`<img src="${ src }" />`);
        $(document.body).append(shadow);
        shadow.click(function () {
            $(this).remove();
        });
    }

    //页面滚动时 或者 刚进入页面时为界面元素添加动画
    function checkScrollForAnimate() {
        //场馆专业系统解决方案动画
        addAnimateClassName('h1', 'animate__lightSpeedInLeft');
        addAnimateClassName('#scheme .scheme-items .item', 'animate__fadeInUp');
        addAnimateClassName('#scheme .scheme-content', 'animate__fadeInUp');
        //更多方案
        addAnimateClassName('#more-scheme h3', 'animate__bounceIn');
        addAnimateClassName('#more-scheme li', 'animate__bounceInLeft');
        //产品展示
        addAnimateClassName('#product-show h3', 'animate__fadeInUp');
        addAnimateClassName('#product-show .item', 'animate__fadeInUp');

        //大型场馆项目案例
        addAnimateClassName('#big-scheme .item .item-text', 'animate__slideInLeft', {
            even: true,
            className: "animate__slideInRight"
        });
        addAnimateClassName('#big-scheme .item .years', 'animate__slideInRight', {
            even: true,
            className: "animate__slideInLeft"
        });
    }

    function addAnimateClassName(slelector, className, options) {
        $(slelector).each(function () {
            let replaceClassName;
            if (options && options.even) {
                let even = ($(this).parents('.item').index() + 1) % 2;
                if (even === 0) replaceClassName = options.className;
            }
            if (domIsInView(this))
                $(this).addClass(`animate__animated ${ replaceClassName || className }`);
        });
    }

    /**
     * 判断元素
     * @param dom 原生js对象
     */
    function domIsInView(dom) {
        const offsetTop = $(dom).offset().top;
        const scrollTop = $(window).scrollTop();
        const viewHeight = $(window).height();
        const height = $(dom).outerHeight();

        return (scrollTop + viewHeight) > offsetTop;
    }

    //滚动时自动选中顶部导航
    function checkForHeaderActive(){
        const doms = ["header","scheme", "product-show", "big-scheme"];
        const scrollTop = $(window).scrollTop();
        const scrollHeight = $(document).height();
        const viewHeight = $(window).height();
        doms.forEach((id, index)=>{
            const offsetTop = $(`#${id}`).offset().top;
            if(offsetTop - scrollTop < 100 && (offsetTop - scrollTop > 0)){
                $("#header .nav li.active").removeClass('active');
                $("#header .nav li").eq(index).addClass('active');
                if(location.hash !== `#${doms[index]}`){
                    location.hash = `#${doms[index]}`;
                }
            }
        });
    }
});
